import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "blog-area ptb-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-9 order-2 order-lg-1" }
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "blog-single-item transition-y" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "blog-content" }
const _hoisted_9 = { class: "d-flex align-items-center flex-wrap ps-0 mb-0" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "col-lg-12" }
const _hoisted_13 = { class: "pagination-area text-center mt-4" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "col-lg-3 order-1 order-lg-2 mb-5 mb-lg-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SidebarWidget = _resolveComponent("SidebarWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "section-title m-auto text-center mw-860" }, [
        _createElementVNode("span", { class: "top-title" }, "مدونتنا"),
        _createElementVNode("h2", null, "أحدث مقالاتنا حول عالم البث الرقمي")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedBlogs, (blog, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-xl-4 col-md-6"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_RouterLink, {
                    to: blog.link,
                    class: "d-block blog-img"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: blog.image,
                        alt: blog.title
                      }, null, 8, _hoisted_7)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_RouterLink, {
                      to: blog.tagLink,
                      class: "tag"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(blog.category), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createElementVNode("h3", null, [
                      _createVNode(_component_RouterLink, {
                        to: blog.link
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(blog.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("ul", _hoisted_9, [
                      _createElementVNode("li", _hoisted_10, [
                        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ti ti-calendar-week" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(blog.date), 1)
                      ]),
                      _createElementVNode("li", _hoisted_11, [
                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ti ti-clock" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(blog.readTime) + " دقيقة قراءة", 1)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", {
                  class: _normalizeClass(["next page-numbers", { disabled: _ctx.currentPage === 1 }]),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  style: {"cursor":"pointer"}
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "ri-arrow-left-s-line" }, null, -1)
                ]))], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: page,
                    class: _normalizeClass(["page-numbers", { current: _ctx.currentPage === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page)),
                    style: {"cursor":"pointer"}
                  }, _toDisplayString(page), 11, _hoisted_14))
                }), 128)),
                _createElementVNode("span", {
                  class: _normalizeClass(["next page-numbers", { disabled: _ctx.currentPage === _ctx.totalPages }]),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  style: {"cursor":"pointer"}
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "ri-arrow-right-s-line" }, null, -1)
                ]))], 2)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_SidebarWidget)
        ])
      ])
    ])
  ]))
}